import React from 'react';

import './Logo.scss';

export const Logo = () => (
	<a
		className="hoki-skateboards-logo"
		href="https://hokiskateboards.com"
		rel="noreferrer"
		target="_blank"
		title="Hoki Skateboards"
	>
		<img
			alt="Hoki Skateboards"
			className="center"
			height="142px"
			src="http://links.hokiskateboards.com/images/logo.png"
			width="275px"
		/>
	</a>
);
